<template>
  <div>
    <div class="divRecapitulatif">
      <h4 id="titre" class="titre">Récapitulatif de votre commande<i v-if="!noEmojis" class="em em-partying_face" aria-role="presentation"
          aria-label="FACE WITH PARTY HORN AND PARTY HAT"></i></h4>
      <div id="recapDefipix">
        <img id="imgRecapDefipix"
          :src="'https://preprod.api.defipix.fr/ressource/booth/picture/'+this.$store.getters.reservation_client.borne.picture"
          alt="Illustration de votre défipix" />
        <h4 id="titreRecapDefipix">Défipix {{ this.$store.getters.reservation_client.borne.name }}</h4>
        <h4 id="dateRecapDefipix">{{ dateFR }}</h4>
        <h4 v-if="this.$store.getters.reservation_client.livraison.mode == 'retrait'">Retrait dans nos locaux</h4>
        <h4 v-else-if="this.$store.getters.reservation_client.livraison.mode == 'transporteur'">Envoi par transporteur
        </h4>
        <h4 v-else-if="this.$store.getters.reservation_client.livraison.mode == 'livraison'">Livraison par nos soins</h4>
      </div>
      <div id="recap">
        <div v-if="listOptionSelected.length" id="recapOption">
          <h5 class="recapTitre">Vos options</h5>
          <table style="width:100%">
            <tr v-for="(option, index) in listOptionSelected" :key=index>
              <td v-if="option.price" class="optTitle" :key="`opt_${index}_title`">{{ option.name }} :</td>
              <td v-else class="optTitle" :key="`opt_${index}_title`">{{ option.name }} {{ option.select.label }} :<br /> {{ option.select[1] }}
              </td>
              <td class="paramOption" :key="`opt_${index}_param`">
                <span class="optPrice"
                  v-if="option.price && $store.getters.reservation_client.client.typeClient === 'Particulier'">{{ option.price }}€</span>
                <span class="optPrice"
                  v-if="option.price && $store.getters.reservation_client.client.typeClient === 'Professionnel'">{{ (Number(option.price)-Number(option.price/5)).toFixed(2) }}€
                  HT</span>
                <span class="optPrice"
                  v-else-if="!option.price && $store.getters.reservation_client.client.typeClient === 'Particulier'">{{ option.select.price }}€</span>
                <span class="optPrice"
                  v-else-if="!option.price && $store.getters.reservation_client.client.typeClient === 'Professionnel'">{{ (Number(option.select.price)-Number(option.select.price/5)).toFixed(2) }}€
                  HT</span>
                <img class="imgRmOption" @click="removeOption(option.id)"
                  :src="'https://preprod.api.defipix.fr/logos/trash_200.png'" alt="remove the option" />
              </td>
            </tr>
          </table>
        </div>
        <div id="recapMontant">
          <div v-if="listOptionSelected.length" class="borderMargin"></div>
          <h5 class="recapTitre">Montant</h5>
          <table style="width:100%">
            <tr>
              <td class="optTitle">Borne :</td>
              <td v-if="$store.getters.reservation_client.client.typeClient === 'Particulier'" class="optPrice">
                {{ this.$store.getters.reservation_client.borne.price }}€</td>
              <td v-else-if="$store.getters.reservation_client.client.typeClient === 'Professionnel'" class="optPrice">
                {{ (Number(this.$store.getters.reservation_client.borne.price)-Number(this.$store.getters.reservation_client.borne.price/5)).toFixed(2) }}€
                HT</td>
            </tr>
            <tr>
              <td class="optTitle" v-if="listOptionSelected.length">Option(s) :</td>
              <td class="optPrice"
                v-if="listOptionSelected.length && $store.getters.reservation_client.client.typeClient === 'Particulier'">
                {{ totalOptions }}€</td>
              <td class="optPrice"
                v-if="listOptionSelected.length && $store.getters.reservation_client.client.typeClient === 'Professionnel'">
                {{ (Number(totalOptions)-Number(totalOptions/5)).toFixed(2) }}€ HT</td>
            </tr>
            <tr>
              <td class="optTitle">Mode de livraison :</td>
              <td v-if="$store.getters.reservation_client.client.typeClient === 'Particulier'" class="optPrice">
                {{ this.$store.getters.reservation_client.livraison.price }}€</td>
              <td v-else-if="$store.getters.reservation_client.client.typeClient === 'Professionnel'" class="optPrice">
                {{ (Number(this.$store.getters.reservation_client.livraison.price)-Number(this.$store.getters.reservation_client.livraison.price/5)).toFixed(2) }}€
                HT</td>
            </tr>
            <tr id="totalPrice">
              <td class="optTitle">Total :</td>
              <td v-if="$store.getters.reservation_client.client.typeClient === 'Particulier'" class="optPrice">
                {{ coutTotal }}€</td>
              <td v-else-if="$store.getters.reservation_client.client.typeClient === 'Professionnel'" class="optPrice">
                {{ (Number(coutTotal)-Number(coutTotal/5)).toFixed(2) }}€ HT ({{ coutTotal }}€ ttc)</td>
            </tr>
          </table>
        </div>
        <div id="recapMail">
          <div class="borderMargin"></div>
          <h5 class="recapTitre">E-mail*<i class="em em-email" aria-role="presentation" aria-label="ENVELOPE" /></h5>
          <input v-model="client.mailClient" type="email" id="mailClient">
        </div>
        <div id="recapMethodPay">
          <div class="borderMargin"></div>
          <h5 class="recapTitre">Sélectionnez votre moyen de paiement</h5>
          <div id="divTermCond">
            <input type="checkbox" id="termeConditionCheck" value="1" name="termeConditionCheck" />
            <a target="_blank" id="linkTermeCondition" href="https://www.defipix.fr/conditions-generales-de-vente/">Je
              m'engage à accepter les Termes &amp; Conditions.</a>
          </div>
          <div class="listMethodPay" id="listMethodPay">
            <div class="divMethodPay" @click="sendReservation('DemandeDevis')">
              <img class="illusMethodPay" id="demandeDevis"
                src="https://preprod.api.defipix.fr/ressource/reservation/image/devis400.png" alt="Demande de devis" />
              <p>Demande de devis</p>
            </div>
            <div class="divMethodPay" @click="sendReservation('Cheque')">
              <img class="illusMethodPay" id="demandeDevisCH"
                src="https://preprod.api.defipix.fr/ressource/reservation/image/cheque400.png"
                alt="Paiement par chèque ou virement" />
              <p>Paiement par chèque ou virement</p>
            </div>
            <div class="divMethodPay" @click="sendReservation('CB1fois')">
              <img class="illusMethodPay" id="CB"
                src="https://preprod.api.defipix.fr/ressource/reservation/image/cb400.png"
                alt="Paiement par carte bleue" />
              <p>Paiement par carte bleue</p>
            </div>
            <div class="divMethodPay" @click="sendReservation('CB3fois')">
              <img class="illusMethodPay" id="3xCB"
                src="https://preprod.api.defipix.fr/ressource/reservation/image/3xcb400.png"
                alt="Paiement par carte bleue en 3 fois sans frais" />
              <p>Paiement par carte bleue en 3 fois sans frais</p>
            </div>
          </div>
          <img id="loadingImgSubmit" class="imgLoader"
            src="https://preprod.api.defipix.fr/ressource/reservation/image/loader.gif" alt="Chargement en cours" />
        </div>
      </div>
      <NavBar id="navBar" :prev="true" :next="true" :nextValue="'Terminé !'" :hideFingerNext="true"
        :disableNext="true" />
    </div>  
    <transition name="fade">
        <AlertSelectPayment v-if="alertSelectPayment" />
    </transition>
  </div>
</template>

<script>
import NavBar from "@/components/OrderBooth/NavBar"
import AlertSelectPayment from "@/components/OrderBooth/AlertSelectPayment"
import axios from 'axios'
import JQuery from 'jquery'
let $ = JQuery;

export default {
  data() {
    return {
      client: {
        mailClient: this.$store.getters.reservation_client.client.mail,
        telClient: this.$store.getters.reservation_client.client.telPortable,
      },
      noEmojis: this.$store.getters.reservation_client.noEmojis,
      alertSelectPayment: false,
    }
  },
  computed: {
    dateFR: function () {
      let date = new Date(
        this.$store.getters.reservation_client.evenement.date
      );
      const options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric"
      };
      return date.toLocaleDateString("fr-FR", options);
    },
    totalOptions: function () {
      let totalOpt = 0;
      for (var i = 0; i < this.$store.getters.reservation_client.optionSelected.length; i++) {
        if (!this.$store.getters.reservation_client.optionSelected[i].price) {
          totalOpt += Number(
            this.$store.getters.reservation_client.optionSelected[i].select.price
          );
        } else {
          totalOpt += Number(
            this.$store.getters.reservation_client.optionSelected[i].price
          );
        }
      }
      return totalOpt;
    },
    coutTotal: function () {
      return (
        Number(this.totalOptions) +
        Number(this.$store.getters.reservation_client.borne.price) +
        Number(this.$store.getters.reservation_client.livraison.price)
      );
    },
    listOptionSelected: function () {
      let listOptionSelected = this.$store.getters.reservation_client.optionSelected;
      return listOptionSelected;
    }
  },
  components: {
    NavBar,
    AlertSelectPayment
  },
  mounted: function () {
    $('html,body').animate({scrollTop: 0}, 'slow');
    this.addRetraitByNight();
  },
  methods: {
    addRetraitByNight() {
        if (this.$store.getters.reservation_client.evenement.heureFin != "Non précisé") {
            let timeEnd = this.$store.getters.reservation_client.evenement.heureFin.split(' ');
            timeEnd = timeEnd[timeEnd.length - 1].split('h')[0];
            if (timeEnd <= 6) {
                let addRDN = true;
                this.listOptionSelected.forEach(element => {
                    if (element.id === 17) addRDN = false;
                });
                if (addRDN) {
                    let self = this;
                    axios.get('https://preprod.api.defipix.fr/option/17')
                    .then(function (response) {
                        let retraitDeNuit = response.data;
                        delete retraitDeNuit.long_description;
                        delete retraitDeNuit.description;
                        delete retraitDeNuit.booth;
                        delete retraitDeNuit.createdAt;
                        delete retraitDeNuit.updatedAt;
                        delete retraitDeNuit.included;
                        delete retraitDeNuit.option_select;
                        delete retraitDeNuit.best_seller;
                        delete retraitDeNuit.imageArray;
                        self.$store.commit('RCaddOption', retraitDeNuit);
                    })
                }
            } else {
                this.$store.commit('RCrmOption', 17);
            }
        } else {
            this.$store.commit('RCrmOption', 17);
        }
    },
    sendReservation(modePay) {
      this.$store.commit('RCsetMailTel', this.client);

      let numeroDevis;
      if ($('#termeConditionCheck').is(":checked") == false) {
        $("#linkTermeCondition").fadeIn(100).fadeOut(100).fadeIn(100).fadeOut(100).fadeIn(100).fadeOut(100).fadeIn(100);
        return;
      }

      $("#loadingImgSubmit").css('display', 'block');
      $("#divTermCond").hide();
      $("#listMethodPay").hide();
      $("#navBar").hide();
      $("#mailClient").prop('disabled', true);

      let self = this;
      axios.post('https://preprod.api.defipix.fr/reservation', {
          sendMail: true,
          total_amount: this.coutTotal,
          booth_amount: this.$store.getters.reservation_client.borne.price,
          booth: this.$store.getters.reservation_client.borne.name,
          delivery_amount: this.$store.getters.reservation_client.livraison.price,
          delivery: this.$store.getters.reservation_client.livraison.mode,
          option_amount: this.totalOptions,
          option_selected: this.listOptionSelected,
          event_date: this.$store.getters.reservation_client.evenement.date,
          event_address: this.$store.getters.reservation_client.evenement.adresse,
          event_type: this.$store.getters.reservation_client.evenement.type,
          event_start_time: this.$store.getters.reservation_client.evenement.heureDebut,
          event_end_time: this.$store.getters.reservation_client.evenement.heureFin,
          event_amount_guest: this.$store.getters.reservation_client.evenement.nbInvites,
          client_type: this.$store.getters.reservation_client.client.typeClient,
          client_society: this.$store.getters.reservation_client.client.societe,
          client_phone: this.$store.getters.reservation_client.client.telPortable,
          client_mail: this.$store.getters.reservation_client.client.mail,
          client_first_name: this.$store.getters.reservation_client.client.prenom,
          client_last_name: this.$store.getters.reservation_client.client.nom,
          client_address: this.$store.getters.reservation_client.client.adresse,
          client_commentary: this.$store.getters.reservation_client.evenement.commentaire,
          state: "created",
          payment_method: modePay,
        })
        .then(function (response) {
          let devis = response.data;

          axios.put(`https://preprod.api.defipix.fr/pre_reservation/${self.$store.getters.reservation_client.pre_reservation}`, {
            date: devis.event_date,
            address: self.$store.getters.reservation_client.evenement.adresse,
            booth: self.$store.getters.reservation_client.borne.name,
            mail: self.$store.getters.reservation_client.client.mail,
            phone: self.$store.getters.reservation_client.client.telPortable,
            reservation_name: devis.name
          });

          let form = document.createElement("form");
          form.setAttribute("method", "post");

          const FormAmount = document.createElement("input");
          FormAmount.setAttribute("type", "hidden");
          FormAmount.setAttribute("name", "amount");
          FormAmount.setAttribute("value", devis.total_amount);
          form.appendChild(FormAmount);

          const FormFreeText = document.createElement("input");
          FormFreeText.setAttribute("type", "hidden");
          FormFreeText.setAttribute("name", "freeText");
          FormFreeText.setAttribute("value", `Reservation|${devis.id}`);
          form.appendChild(FormFreeText);

          const FormReference = document.createElement("input");
          FormReference.setAttribute("type", "hidden");
          FormReference.setAttribute("name", "reference");
          FormReference.setAttribute("value", devis.name);
          form.appendChild(FormReference);

          const FormEmail = document.createElement("input");
          FormEmail.setAttribute("type", "hidden");
          FormEmail.setAttribute("name", "email");
          FormEmail.setAttribute("value", devis.client_mail);
          form.appendChild(FormEmail);

          if (modePay == "CB1fois") {
            form.setAttribute("action", "https://defipix.fr/paiement/Payment1.php");
            document.body.appendChild(form);
            form.submit();
          } else if (modePay == "CB3fois") {
            const montant3 = Math.round(self.coutTotal / 3);
            const montant2 = Math.round(self.coutTotal / 3);
            const montant1 = self.coutTotal - (montant3 + montant2);
            const FormEcheance1 = document.createElement("input");
            FormEcheance1.setAttribute("type", "hidden");
            FormEcheance1.setAttribute("name", "echeance1");
            FormEcheance1.setAttribute("value", montant3);
            form.appendChild(FormEcheance1);

            const FormEcheance2 = document.createElement("input");
            FormEcheance2.setAttribute("type", "hidden");
            FormEcheance2.setAttribute("name", "echeance2");
            FormEcheance2.setAttribute("value", montant2);
            form.appendChild(FormEcheance2);

            const FormEcheance3 = document.createElement("input");
            FormEcheance3.setAttribute("type", "hidden");
            FormEcheance3.setAttribute("name", "echeance3");
            FormEcheance3.setAttribute("value", montant1);
            form.appendChild(FormEcheance3);

            form.setAttribute("action", "https://defipix.fr/paiement/Payment3.php");
            document.body.appendChild(form);
            form.submit();
          } else {
            self.$store.commit('RCetapeNext');
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    removeOption(id) {
      this.$store.commit('RCrmOption', id);
    },
    nextStep() {
        // $("#listMethodPay").fadeIn(200).fadeOut(200).fadeIn(200).fadeOut(200).fadeIn(200).fadeOut(200).fadeIn(200);
        this.alertSelectPayment = true;
    }
  },
};
</script>

<style scoped>

h4, h5 {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
}

.divRecapitulatif {
    margin-bottom: 2em;
    background-color: rgb(248, 248, 248);
    border-radius: 10px;
    padding: 2em 1em 1em 1em;
    box-shadow: 0px 0px 5px 0px #aaa;
    background-color: #25327B;
    display: grid;
    grid-template-columns: 40% 60%;
    grid-template-areas:
        'titre titre'
        'recapDefipix recap'
        'navBar navBar';
}

h5, h4, h3, h2, h1, p, .recapTitre {
    color: #fff !important;
}

p {
    margin-bottom: 0;
}

.recapTitre {
    text-align: center;
    color: #25327B;
}

.borderMargin {
    width: -webkit-fill-available;
    margin: .65em 3em;
    border-top: 2px solid #f677c4;
}

#titre {
    grid-area: titre;    
}

.titre {
    color: #fff;
    padding: 0;
}

/* Colonne récapitulatif */

#recap {
    display: flex;
    flex-direction: column;
    justify-content: center;
}

/* Borne */
#recapDefipix {
    grid-area: recapDefipix;
    text-align: center;
}

#imgRecapDefipix {
    max-width: 100%;
    max-height: 30em;
    margin: auto;
}

/* Option */
#recapOption {
    grid-area: recapOption;
    border: unset;
}

.optTitle {
    display: table-cell;
    width: 50%;
    text-align: right;
    color: #fff;
    vertical-align: top;
}

.optPrice {
    padding-left: 15px;
    display: table-cell;
    vertical-align: top;
    color: #fff;
}

.paramOption {
    display: grid;
    grid-template-columns: 7.25em auto;
    grid-gap: 1em;
}

.imgRmOption {
    width: 1.2em;
}

.imgRmOption:hover {
    cursor: pointer;
    transform: scale(1.1);
}

/* Montant */

#recapMontant {
    grid-area: recapMontant;
}

#recapMontant, #recapListOption {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
}

#montant {
    text-align: right;
    margin-left: 4em;
}
#total {
    margin-left: 5px;
    text-align: left;
}

#montant,
#total {
    flex: 1;
}

/* Email */
#recapMail {
    grid-area: recapMail;
    text-align: center;
}

#recapMail>input {
    width: 18em !important;
    text-align: center;
}

#totalPrice {
    font-size: 24px;
}


/* Mode de paiement */
#recapMethodPay {
    grid-area: recapMethodPay;
    padding-bottom: 0;
}

.listMethodPay {
    display: flex;
    justify-content: center;
    margin: auto 10em;
}

.divMethodPay {
    flex: 1;
    margin: 0 1em;
}

.illusMethodPay {
    cursor: pointer;
    width: 100px;
    margin: auto;
    display: block;
}

.divMethodPay:hover {
    transform: scale(1.02);
    cursor: pointer;
}

.divMethodPay>p,
#divTermCond {
    text-align: center;
    font-size: 12px;
}

#loadingImgSubmit {
    display: none;
    margin: 2em auto;
}

/* navbar */
#navBar {
    grid-area: navBar;
    padding: 0;  
}

a {
    color: #f774c4;
    font-weight: 700;
}

/* Transition fade */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 1s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

@media only screen and (max-width: 968px) {
    .divRecapitulatif {
        display: block;
    }

    #navBar {
        grid-area: navBar;
        padding-bottom: 3em;  
    }

    #recapOption {
        border-top: 2px solid #f677c4;
    }
}

@media only screen and (max-width: 768px) {
  .listMethodPay {
    display: grid;
    grid-template-columns:
    /* 1 */ 50%
    /* 2 */ 50%;
    margin: auto;
  }

  .divMethodPay {
    margin: 0;
  }

  .borderMargin {
    margin: .5em auto;
  }

  .paramOption {
    grid-template-columns: 5em auto;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/OrderBooth/Order.vue